<template>
      <div class="fright  cright" >
        <a-form-model ref="form" action="" :rules="rules" :model="model">
          <div class="mt20">
            <span class="redtxt fleft" style="margin-left: 30px;margin-top: 10px;margin-right: -20px">*</span>
            <span class="label fleft" style="margin-left: 30px;margin-top: 10px" prop="name">姓名:</span>
            <a-form-model-item prop="name" label="姓名" style="float: right">
              <input type="text" class="asktitle" v-model="model.name" @blur="changename" oninput="if(value.length > 11)value = value.slice(0, 20)">
            </a-form-model-item>
          </div>

          <div class="mt20">
            <span class="redtxt fleft" style="margin-left: 30px;margin-top: 10px;margin-right: -20px">*</span>
            <span class="label fleft" style="margin-left: 30px;margin-top: 10px" prop="contact">联系方式:</span>
            <a-form-model-item  label="联系方式" prop="contact" style="float: right">
              <input type="text" class="asktitle" v-model="model.contact" @blur="changecontact" maxlength="255">
            </a-form-model-item>
          </div>

          <div class="mt20">
            <span class="label fleft" style="margin-left: 30px;margin-top: 10px">咨询标题:</span>
            <a-form-model-item  label="公示标准" style="margin-left: 10px;float: right">
              <a-select  show-search class="asktitle" placeholder="请选择公示标准" @blur="changeid">
                <a-select-option :value="undefined">请选择公示标准</a-select-option>
                <a-select-option v-for="item in info" v-bind:key="item.id" :value="item.id">
                  {{item.standardname }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>

          <div class="mt20">
            <span class="redtxt fleft" style="margin-left: 30px;margin-top: 10px;margin-right: -20px">*</span>
            <span class="label fleft" style="margin-left: 30px;margin-top: 10px" prop="asktitle">咨询标题:</span>
            <a-form-model-item  label="咨询标题" prop="asktitle" style="float: right">
              <a-input type="text" class="asktitle" v-model="model.asktitle" size="large" autocomplete="false" @blur="changetitle" maxlength="255"/>
            </a-form-model-item>
          </div>

            <div class="mt20">
              <span class="redtxt fleft" style="margin-left: 30px;margin-top: 10px;margin-right: -20px">*</span>
              <span class="label fleft" style="margin-left: 30px;margin-top: 10px" prop="askcontent">咨询内容:</span>
              <a-form-model-item  label="咨询内容" prop="askcontent" style="float: right">
                <textarea class="askcontent" v-model="model.askcontent"  @blur="changecontent"></textarea>
              </a-form-model-item>
            </div>

          <a-row :gutter="0" style="margin-left: 150px">
            <a-col :span="8" >
              <a-form-model-item required prop="inputCode">
                <a-input v-model="model.inputCode" size="large" type="text" placeholder="请输入验证码" @blur="changeinputCode" style="border: 1px solid black;">
                  <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="text-align: left">
              <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode"/>
              <img v-else style="margin-top: 2px;" src="../../images/checkcode.png" @click="handleChangeCheckCode"/>
            </a-col>
          </a-row>
          <div class="fright tjbtn">
            <button class="cancle" @click="refreash()">取消</button>
            <button class="submit" @click="submitask('form')">提交</button>
          </div>
        </a-form-model>
      </div>
</template>



<script>
  import http from '../../js/axios'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import AFormModelItem from "ant-design-vue/es/form-model/FormItem";
  import StoreProvider from "ant-design-vue/es/_util/store/Provider";

  export default {
    name: 'AquaticWyzx',
    components: {StoreProvider, AFormModelItem},
    data(){
      return{
        model:{
          name:'',
          contact:'',
          inputCode: '',
        },
        data:[],
        info: [],
        disabled:false,
        disablede:false,
        locale: zhCN,
        name:'',
        realname:'',
        contact:'',
        asktitle:null,
        askcontent:null,
        requestCodeSuccess: false,
        randCodeImage: '',
        currdatetime:'',
        id:'',
        standardname:'',
        rules: {
          name: [
            { required: true, message: '请输入你的姓名!'},
          ],
          contact: [
            { required: true, message:'请输入你的联系方式！'},
            { pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9})|(([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+))$/, message: '请输入正确的手机号码、固话号码或邮箱地址!'},
          ],
          asktitle: [
            { required: true, message: '请输入标题!'},
          ],
          askcontent: [
            { required: true, message: '请输入咨询内容!'},
          ],
          inputCode: [
            { required: true, message: '请输入验证码!'},
          ]
        },
      }
    },
    computed:{
    },
    created(){
      this.islogin();
      this.handleChangeCheckCode();
      this.namelist();
      this.getCaseid();
    },
    mounted () {
    },
    methods: {
      /**判断是否登录*/
      islogin(){
        var arr = document.cookie.split('; ');
        if(arr.length>1){
        }else{
          this.$message.warning("您尚未登录，请先登录！")
        }
      },
      /**刷新验证码*/
      handleChangeCheckCode(){
        this.currdatetime = new Date().getTime();
        this.model.inputCode = ''
        http.get(`/randomCode/${this.currdatetime}`).then(res=>{
          if(res.data.success){
            this.randCodeImage = res.data.result
            this.requestCodeSuccess=true
          }else{
            this.$message.error(res.data.message)
            this.requestCodeSuccess=false
          }
        }).catch(()=>{
          this.requestCodeSuccess=false
        })
      },
      /**自动获取姓名和联系方式*/
      namelist(){
        this.model.name = this.$cookies.get('username');
        this.model.contact = this.$cookies.get('userphone');
        /*http.get('/namelist').then(res=>{
          if(res.data.success){
            this.model.name = res.data.message;
            this.realname = this.model.name;
            this.model.contact = res.data.result
          }else{
            this.$message.error(res.data.message)
          }
        })*/
      },
      /**获取caseid*/
      getCaseid(){
        http.get('/getCaseid').then(res=>{
          if(res.data.success){
            this.info = res.data.result
          }else{
            this.$message.error(res.data.message)
          }
        })
      },
      changeid(e){
        this.id = e
      },
      changename(e){
        this.name = e.target.value
      },
      changecontact(e){
        this.contact = e.target.value
      },
      changetitle(e){
        this.asktitle = e.target.value
      },
      changecontent(e){
        this.askcontent = e.target.value
      },
      changeinputCode(e){
        this.inputCode = e.target.value
      },
      //取消按钮刷新页面
      refreash(){
        location.reload()
      },
      //提交
      submitask(formName){
        const that = this;
        this.$refs[formName].validate(valid => {
          this.realname = this.$cookies.get('username');
          var arr = document.cookie.split('; ');
          if(arr.length>1){
            if (valid){
              if (this.realname == null || this.realname=='') {
                this.$message.warning("您尚未登录，请登录后再试！")
              }else {
                if (this.name == null || this.name=='') {
                  this.name = this.model.name
                  this.contact = this.model.contact
                }
                http.get('/addZxfw',{params:{name:this.name,contact:this.contact,asktitle:this.asktitle,askcontent:this.askcontent,captcha:this.inputCode,checkKey:this.currdatetime,caseid:this.id}}
                ).then((res) => {
                  if (res.data.success) {
                    that.$message.success(res.data.message);
                    that.$emit('ok');
                    //提交后自动刷新验证码
                    this.handleChangeCheckCode();
                    //提交成功后自动刷新页面
                    // location.reload()
                  }else {
                    that.$message.warning(res.data.message);
                  }
                })
              }
            }else {
              this.$message.warning("您有相关项未填写，请填写后提交！")
            }
          }else{
            this.$message.warning("您尚未登录，请先登录！")
          }
        })
      },
    },
  }
</script>


<style scoped>
  @import "../../config/AquaticZixun.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticzixun/AquaticWyzx.vue